const wrappedContracts: Record<number, string> = {
  4337: '0xD51BFa777609213A653a2CD067c9A0132a2D316A', // beam
  13337: '0xf65b6f9c94187276c7d91f4f74134751d248bfea', // beam testnet
  13371: '0x3A0C2Ba54D6CBd3121F01b96dFd20e99D1696C9D', // zkevm
  13473: '0x1CcCa691501174B4A623CeDA58cC8f1a76dc3439', // zkevm testnet
  50104: '0x2b1A859dE6A55c553520D7780Bc5805712B128F9', // sophon
  531050104: '0x9B7EA63EF5062661570afe548e3AD691D5652527', // sophon testnet
};

export default wrappedContracts;
